import uniqBy from "lodash/uniqBy";

import {IntermediatePart} from "../../intermediatePart";
import DesignNavigationItem from "../../../../visComponents/designNavigationItem";
import Cabinet from "../../parts/cabinet";
import store from "../../../../../store";
import {METADATA} from "../../constants";
import {getFeatureIsLocked} from "../../../../../misc/helpers";

export default class Hood extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'hood';
    this.partName = 'Hood';
    this.canBeDisabled = true;
    this.translateId = "visualizer.kitchen.appliance.hood";
  }

  load(dbFeature) {
    dbFeature.metaData.Appliance = ["Hood"];
    if (!dbFeature.metaData["CabinetLayout"]) {
      dbFeature.metaData["CabinetLayout"] = [METADATA.ALL]
    }
    if (!dbFeature.metaData["Cabinet"]) {
      dbFeature.metaData["Cabinet"] = [METADATA.ALL]
    }
    return super.load_(dbFeature, new Hood());
  }

  handleClick(ignoreLocked) {
    super.handleClick(ignoreLocked);  // 1) set hood
    if (!this.notAvailableInVisualizer && !getFeatureIsLocked(this, ignoreLocked)) {
      const parent = this.getParent();
      const applianceParent = parent.getParent();
      const cabinetParent = applianceParent.layout.parts[Cabinet.id];
      if (cabinetParent && cabinetParent.topCabinet && cabinetParent.topCabinet.activeFeature
        && cabinetParent.getTopCabinetApplianceType() !== "Hood") {
        const topCabinetConditions = cabinetParent.topCabinet.getArrayOfConditions();
        topCabinetConditions.push({
          propName: "Appliance",
          propValue: "Hood"
        });
        const matchingCabinets = super.navigationSubItemsWithFilterMultipleConditions(
          topCabinetConditions,
          cabinetParent.topCabinet.features
        );
        if (matchingCabinets.length) {
          const currentName = cabinetParent.topCabinet.activeFeature.partName.split(" Microwave")[0];
          const matchingCabinet = matchingCabinets.find(cabinet => {
            return cabinet.partName.split(" Hood")[0] === currentName
          });
          (matchingCabinet || matchingCabinets[0]).handleClick(ignoreLocked);
        }
      }
      this.featureClicked();
    }
  }

  navigationSubItems(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
    let featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(true), filteredAvailableFeatures);
    featuresToDisplay = [
      ...this.getFilteredFeaturesByTopCabinetFilters(featuresToDisplay),
      ...this.getFeaturesMatchingAllCabinets(featuresToDisplay)
    ];
    return uniqBy(featuresToDisplay, (feature) => feature.dbFeature.id)
      .map(_ => new DesignNavigationItem(_.featureName, _));
  }

  setLayers(layout) {
    const cabinetParent = this.getParent().layout.parts[Cabinet.id];
    if (cabinetParent && cabinetParent.getTopCabinetApplianceType() === "Microwave") {
      super.hideLayers();
      return
    }

    if (this.activeFeature && ((
        this.matchesByMetaDataAndFilters() || this.getFeaturesMatchingAllCabinets()
          .some(feature => feature.dbFeature.id === this.activeFeature.dbFeature.id)
      ) || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      super.setLayers(layout);
    } else {
      this.setDefault();
      super.setLayers(layout);
    }
  }

  matchesByMetaDataAndFilters() {
    const cabinetParent = this.getParent().layout.parts[Cabinet.id];
    const topCabinet = cabinetParent.topCabinet;

    if (topCabinet && topCabinet.activeFeature && topCabinet.activeFeature.dbFeature && topCabinet.activeFeature.dbFeature.filterValueIDs) {
      const activeTopCabinetFilters = topCabinet.activeFeature.dbFeature.filterValueIDs;
      const filterGroups = store.getState().filterState.filterGroups;
      const woodTypeFilter = filterGroups.find(group => group.name === "WoodType");
      const stainColorFilter = filterGroups.find(group => group.name === "StainColor");
      return woodTypeFilter && stainColorFilter && this.featureIsMatchingFilters(this.activeFeature, activeTopCabinetFilters, [
        woodTypeFilter, stainColorFilter
      ])
    }
    return this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
  }

  setDefault() {
    const filteredFeatures = this.features.filter(f => f.matchesMetaForArrayOfConditions(this.getArrayOfConditions()));
    const filteredFeaturesByTopCabinetFilters = this.getFilteredFeaturesByTopCabinetFilters(filteredFeatures);
    const featuresMatchingAllCabinets = this.getFeaturesMatchingAllCabinets(filteredFeatures);
    if (filteredFeaturesByTopCabinetFilters.length) {
      this.activeFeature = filteredFeaturesByTopCabinetFilters[0]
    } else {
      // const matchingFeatureExist = super.tryToSetTheSameFeature(filteredFeatures, null);
      // if (!matchingFeatureExist) {
        this.activeFeature = featuresMatchingAllCabinets[0] || filteredFeatures[0] || null;
      // }
    }
  }

  getFeaturesMatchingAllCabinets(filteredFeatures = this.features) {
    return filteredFeatures.filter((feature) => {
      return feature.dbFeature.metaData["CabinetLayout"].includes(METADATA.ALL)
        || feature.dbFeature.metaData["Cabinet"].includes(METADATA.ALL)
    });
  }

  getFilteredFeaturesByTopCabinetFilters(filteredFeatures) {
    const cabinetParent = this.getParent().layout.parts[Cabinet.id];
    const topCabinet = cabinetParent.topCabinet;

    if (topCabinet && topCabinet.activeFeature && topCabinet.activeFeature.dbFeature && topCabinet.activeFeature.dbFeature.filterValueIDs) {
      const activeTopCabinetFilters = topCabinet.activeFeature.dbFeature.filterValueIDs;
      const filterGroups = store.getState().filterState.filterGroups;
      const woodTypeFilter = filterGroups.find(group => group.name === "WoodType");
      const stainColorFilter = filterGroups.find(group => group.name === "StainColor");

      return filteredFeatures.filter((currentFeature) => {
        return woodTypeFilter && stainColorFilter && this.featureIsMatchingFilters(currentFeature, activeTopCabinetFilters, [
          woodTypeFilter, stainColorFilter
        ])
      });
    }
    return filteredFeatures
  }

  getArrayOfConditions(ignoreConditions) {
    const cabinetParent = this.getParent().layout.parts[Cabinet.id];
    const conditions = [{
      propName: "Cabinet",
      propValue: cabinetParent.getTopCabinetType()
    },{
      propName: 'CabinetLayout',
      propValue: cabinetParent.getTopCabinetShadowLayout()
    }];
    if (!ignoreConditions) {
      conditions.push({
        propName: "Appliance",
        propValue: cabinetParent.getTopCabinetApplianceType()
      })
    }
    return conditions;
  }

  setZIndex(zIndexes) {
    if(zIndexes) {
      const zIndex = zIndexes.Appliances.Hood;
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndex;
      }
      if (this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndex;
      }
    }
  }
}
